import { requests } from '@/libs/axios/axios'
import { MostAskedQuestions } from '@/store/slices/chat/chat-slice.interfaces'
import { AxiosResponse } from 'axios'
import { ChatEndpoints } from '../chat-endpoints'

export const getMostAskedQuestions = async (): Promise<AxiosResponse<MostAskedQuestions[]>> => {
  return requests.get(ChatEndpoints.GET_MOST_ASKED_QUESTIONS)
}
